import { CognitoUser } from 'app/Login/lib/CognitoUser';
import { truncate } from 'fs';
import * as React from 'react'
import { Alert, Button, Col, Container, Form, FormGroup, Input, Label, Row } from 'reactstrap';
import { HttpRequest } from 'util/http';
import { PasswordValidationComponent } from '../ProfileContainer/lib/passwordValidationComponent';

interface IForgotPasswordState {
  showNotificationMessage?: boolean
  notification?: string
  username?: string
  showConfirmationBox: boolean
  password: string
  confirmPassword: string
  confirmation: string
  showMismatchedPasswords: boolean
  submitting: boolean
  showDoneButton: boolean
  lowerCase?: boolean
  match?: boolean
  specialChar?: boolean
  upperCase?: boolean
  validLength?: boolean
  numericChar?: boolean
}

interface IForgotPasswordResponse {
  status?: number
  notification?: string
  error?: string
}

export class ForgotPasswordContainer extends React.Component<{}, IForgotPasswordState> {
  state: IForgotPasswordState = {
    notification: '',
    showNotificationMessage: false,
    username: '',
    showConfirmationBox: false,
    password: '',
    confirmPassword: '',
    confirmation: '',
    showMismatchedPasswords: false,
    submitting: false,
    showDoneButton: false,
  }

  componentDidUpdate(prevProps, prevState: IForgotPasswordState) {
    if (prevState.password !== this.state.password || prevState.confirmPassword !== this.state.confirmPassword) {
      const { password, confirmPassword } = this.state
      // add password validation to enforce password requirements
      this.setState({
        validLength: password.length >= 10,
        upperCase: password.toLowerCase() !== password,
        lowerCase: password.toUpperCase() !== password,
        specialChar: /[ `!@#$%^&*()_+\-=\]{};':"\\|,.<>?~]/.test(password),
        match: password && password === confirmPassword,
        numericChar: /\d/.test(password),
      })
    }
  }

  updateUsername(username) {
    this.setState({ username })
  }

  resetPassword(e) {
    e.preventDefault()
    const { username } = this.state

    this.setState({ submitting: true })

    // Call the PHP script to check if the Cognito user exists
    const data = { username }
    const method = 'POST'
    HttpRequest.fetch('/scripts/users/check_if_cognito_user_exists', { data, method }).then((responseData: any) => {
      // @ts-ignore
      const error = data.error;
      if (error) {
        // Handle error returned by PHP
        // @ts-ignore
        this.setState({
          submitting: false,
          showNotificationMessage: true,
          notification: `Error: ${error}`,
          showConfirmationBox: false
        });
        return;
      }
      // Log the value of add_cu for debugging purposes
      // @ts-ignore
      const addCognitoUser = responseData.wasCreated;
      // tslint:disable-next-line:no-console
      console.log('add_cu value:', addCognitoUser);

      if (addCognitoUser) {
        // Add logic here if the user should be added to Cognito
        const newCognitoUser = new CognitoUser(username);
        newCognitoUser.signUpUser(username, responseData.email, crypto.randomUUID(), responseData.cognito_username).then((result) => {
          const cognitouser = new CognitoUser(username)
          cognitouser.forgotPassword(username).then((forgotPasswordResult) => {
            this.setState({
              submitting: false,
              showNotificationMessage: true,
              notification: 'An email has been sent from techsupport@avannis.com to the email address associated with your username with a code. Enter the code in the field below.',
              showConfirmationBox: true
            })
          }).catch((err: Error) => {
            this.setState({
              submitting: false,
              showNotificationMessage: true,
              notification: err.message,
              showConfirmationBox: false
            })
          })
          // tslint:disable-next-line:no-console
          console.log(result);
        }).catch((err) => {
          // tslint:disable-next-line:no-console
          console.log(err);
        });
      } else {
        const cognitouser = new CognitoUser(username)
        cognitouser.forgotPassword(username).then((result) => {
          this.setState({
            submitting: false,
            showNotificationMessage: true,
            notification: 'An email has been sent from techsupport@avannis.com to the email address associated with your username with a code. Enter the code in the field below.',
            showConfirmationBox: true
          })
        }).catch((err: Error) => {
          this.setState({
            submitting: false,
            showNotificationMessage: true,
            notification: err.message,
            showConfirmationBox: false
          })
        })
      }

    })
      .catch((err) => {
        // Handle network or fetch-related errors
        this.setState({
          submitting: false,
          showNotificationMessage: true,
          notification: `Error checking username: ${err.message}`,
          showConfirmationBox: false
        });
      });
  }

  async confirmPassword(e) {
    e.preventDefault()

    const { password, confirmPassword, username, confirmation } = this.state

    this.setState({ submitting: true })

    if (password !== confirmPassword) {
      this.setState({ notification: 'Your passwords do not match', submitting: false })
      return
    } else {
      this.setState({ notification: '' })
    }

    try {
      const cognitoUser = new CognitoUser(username)

      await cognitoUser.updatePassword(confirmation, password, username)

      //NOTE: Display success message. Then redirect to login page.
      const showNotificationMessage = true
      const notification = 'Password updated successfully.'
      this.setState({ showNotificationMessage, notification, submitting: false, showDoneButton: true })
    } catch (err) {
      // tslint:disable-next-line:no-console
      console.log(err)
      const showNotificationMessage = true
      const notification = (err.message ? err.message : 'There was an error.')
      this.setState({ showNotificationMessage, notification, submitting: false })
    }
  }

  redirectToLogin(e) {
    window.location.href = 'login'
  }

  renderNotification() {
    const { notification } = this.state
    return notification
  }

  render() {
    const { showNotificationMessage, notification, username, showConfirmationBox, lowerCase, match, specialChar, upperCase, validLength, numericChar } = this.state

    return (

      <div className="blacklight">
        <Row style={{ marginTop: '10%' }}>
          <Col sm={12} md={4} lg={3} style={{ color: '#fff', background: 'var(--brand-navy)', height: '90px', padding: '7px 0 0 7px' }}>
          </Col>
          <Col sm={12} md={8} lg={9} style={{ color: '#fff', background: 'var(--brand-navy)' }}>
            <a href="login"><img src="/images/logos/avannis_logo_white.png" height="80px;" alt="Avannis" width=""></img></a>
          </Col>
        </Row>
        <Row className="rowNoMarginTop">
          <Col sm={12} md={4} lg={3} style={{ backgroundColor: 'var(--brand-white)', height: '1px' }}>
          </Col>
          <Col sm={12} md={8} lg={9} style={{ backgroundColor: 'white', padding: '20px' }}>
            <Container>
              <section>
                <h3>Forgot Password</h3>
                {
                  showNotificationMessage ?
                    <ul style={{ backgroundColor: 'var(--brand-pink)', padding: '10px', color: '#fff', fontWeight: 'bold' }}>
                      <li style={{ backgroundColor: 'var(--brand-pink)' }}>{this.renderNotification()}</li> </ul> :
                    null
                }
              </section>
              <Row>
                <Col sm={12}>
                  {
                    showConfirmationBox ?
                      (
                        <form onSubmit={(e) => this.confirmPassword(e)} className="padding" noValidate>
                          <Row>
                            <Col md={6}>
                              <FormGroup>
                                <Label>Username</Label>
                                <Input type="text" value={username} onChange={(e) => this.updateUsername(e.currentTarget.value)} />
                              </FormGroup>
                            </Col>
                            <Col md={6}>
                              <FormGroup>
                                <Label>Confirmation Code</Label>
                                <Input value={this.state.confirmation} onChange={(e) => this.setState({ confirmation: e.currentTarget.value })} />
                              </FormGroup>
                            </Col>
                          </Row>
                          <PasswordValidationComponent
                            password={this.state.password}
                            setPassword={(e) => this.setState({ password: e.currentTarget.value })}
                            confirmationPassword={this.state.confirmPassword}
                            setConfirmationPassword={(e) => this.setState({ confirmPassword: e.currentTarget.value })}
                            isValid={validLength && upperCase && lowerCase && specialChar && numericChar}
                            lowerCase={lowerCase}
                            match={match}
                            specialChar={specialChar}
                            upperCase={upperCase}
                            validLength={validLength}
                            numericChar={numericChar}
                          />
                          <Row style={{ paddingBottom: '20px' }}>
                            <Col md={6}>
                            </Col>
                            <Col md={6}>

                              {
                                this.state.showDoneButton ?
                                  <Button onClick={(e) => this.redirectToLogin(e)}>Go To Login</Button> :
                                  <Button color="primary" disabled={this.state.submitting || !(validLength && upperCase && lowerCase && specialChar) || !match}>
                                    {this.state.submitting ?
                                      <>
                                        <span>Submiting...&nbsp;</span>
                                        <i className="fas fa-fw fa-cog fa-spin" />
                                      </>
                                      :
                                      <>
                                        <span>Submit&nbsp;</span>
                                        <i className="fas fa-fw fa-paper-plane" />
                                      </>
                                    }
                                  </Button>
                              }
                            </Col>
                          </Row>
                        </form>
                      ) : (
                        <Form onSubmit={(e) => this.resetPassword(e)}>
                          <Row>
                            <Col md={6}>
                              <FormGroup>
                                <Label>UserName</Label>
                                <Input value={username} onChange={(e) => this.updateUsername(e.currentTarget.value)} ></Input>
                              </FormGroup>
                            </Col>
                            <Col md={6}>

                            </Col>
                          </Row>
                          <Row>
                            <Col md={6}>

                              <Button color="primary" disabled={this.state.submitting}>
                                {this.state.submitting ?
                                  <>
                                    <span>Submiting...&nbsp;</span>
                                    <i className="fas fa-fw fa-cog fa-spin" />
                                  </>
                                  :
                                  <>
                                    <span>Submit&nbsp;</span>
                                    <i className="fas fa-fw fa-paper-plane" />
                                  </>
                                }
                              </Button>

                            </Col>
                            <Col md={6}></Col>
                          </Row>
                          <Row>
                            <Col md={6}>
                              <Alert color="light">
                                If you don’t remember your username, please <span className="link" onClick={() => { window.dispatchEvent(new CustomEvent('updateIsModalOpen', { detail: true })); }}>ask for support</span>.
                              </Alert>
                            </Col>
                            <Col md={6}></Col>
                          </Row>
                        </Form>
                      )
                  }
                </Col>
              </Row>
            </Container>
          </Col>
        </Row>
      </div >
    )
  }
}
